import config from "#config";
import { Auth0Client } from "@auth0/auth0-spa-js";

/**
 * Canonical Auth0 SPA client for Validere web. Used by AuthenticatedContext
 * (login, logout, company switch, token refresh) and axios request interceptors.
 *
 * A second client (Redux bootstrap in `authentication.tsx`) must not be used for
 * API tokens: its cache is not updated on company switch, so requests would keep
 * sending the previous company's access token until that cache entry expires.
 */
export const auth0AppClient = new Auth0Client({
  domain: config.DOMAIN,
  clientId: config.CLIENT_ID,
  cacheLocation: "memory",
  authorizationParams: {
    redirect_uri: `${window.location.origin}/app/callback`,
    audience: config.API_ID,
    scope: "openid profile email offline_access",
  },
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
});
